import api from './api';

const connectionStatsService = {
    getStats: async (entityType, entityId, months = 3) => {
        const response = await api.get(`/admin/connection-statistics?entityType=${entityType}&entityId=${entityId}&months=${months}`);
        return response.data;
    },
};

export default connectionStatsService;
